import React, { Component } from 'react';
import { Container, Responsive } from 'semantic-ui-react';
export default class BasicContainer extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                    <Container className="mpost-section" {...this.props}>
                        {this.props.children}
                    </Container>
                </Responsive>
                <Responsive {...Responsive.onlyMobile}>
                    <Container className="mpost-section mobile" {...this.props}>
                        {this.props.children}
                    </Container>
                </Responsive>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/BasicContainer.js